<section class="bb-status-page">
  <div class="bb-status-card">
    <img class="bb-status-img" src="/assets/orderstatus.png" [alt]="'order status' | transloco" />

    <p class="bb-status-title">
      {{ "order completed" | transloco }}
    </p>

    <p class="bb-status-hint">
      {{ "order completed hint" | transloco }}
    </p>
  </div>
</section>